export class PlayerAutoplay {
  constructor(options = {}){
    if (typeof options.autoplay === "undefined") options.autoplay = false;
    if (typeof options.adult === "undefined") options.adult = false;

    this._data = options.autoplay;
    this._adult = options.adult;
  }

  data(){
    return this._data;
  }

  value(){
    return this.data() && !this.isAdult();
  }

  isAdult(){
    return this._adult;
  }
}
